import { TextV2 } from '@insights-ltd/design-library/components';
import { Link as RouterLink } from 'react-router';
import { Link } from '@mui/material';
import { OrganisationViewType } from 'pages/Organisation/typeGuard';

type OrganisationCardLinkState =
  | { activeTab: OrganisationViewType }
  | { organisation: { id: string; name: string } };

type OrganisationCardLinkProps = {
  to: string;
  state?: OrganisationCardLinkState;
  children: React.ReactNode;
};

const OrganisationCardLink = ({
  to,
  state,
  children,
}: OrganisationCardLinkProps) => (
  <Link component={RouterLink} to={to} state={state}>
    <TextV2
      component="p"
      variant="bodyBold"
      sx={(theme) => ({
        lineHeight: '28px !important',
        color: theme.palette.blue.main,
        '&:hover': { color: theme.palette.blue.dark },
        '&:active': { color: theme.palette.text.primary },
      })}
    >
      {children}
    </TextV2>
  </Link>
);

export default OrganisationCardLink;
